import type { ReactNode } from 'react'

import { PageCenteredPlaceholder } from './PageCenteredPlaceholder'

type Props = {
  illustration?: ReactNode
  title: string
  description?: string
  /** emphasis：主标题；muted：图库式单行弱提示 */
  titleTone?: 'emphasis' | 'muted'
  action?: ReactNode
  'aria-label'?: string
  className?: string
}

/**
 * 页面级空列表占位：与 {@link PageAsyncErrorState} 同谱垂直居中布局。
 */
export function PageAsyncEmptyState({
  illustration,
  title,
  description,
  titleTone = 'emphasis',
  action,
  'aria-label': ariaLabel,
  className,
}: Props) {
  const titleClassName =
    titleTone === 'muted'
      ? 'text-sm font-medium text-ink-soft'
      : 'text-sm font-semibold text-ink'

  return (
    <PageCenteredPlaceholder
      role="img"
      aria-label={ariaLabel ?? title}
      className={className}
    >
      {illustration}
      {description ? (
        <div className="space-y-1">
          <p className={titleClassName}>{title}</p>
          <p className="text-sm leading-relaxed text-ink-soft">{description}</p>
        </div>
      ) : (
        <p className={titleClassName}>{title}</p>
      )}
      {action}
    </PageCenteredPlaceholder>
  )
}
